import { createTheme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import typography from './typography';
import getComponents from './components';

const shadowValues = {
  light: '0 2px 8px rgba(0, 0, 0, 0.1)',
  main: '0 4px 12px rgba(0, 0, 0, 0.15)',
  dark: '0 4px 20px rgba(0, 0, 0, 0.1)',
};

// Base theme configuration
const baseTheme = {
  typography,
  spacing: 8, // 8px base spacing
  customShadows: shadowValues,
};

// Light theme for general pages
export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    ...lightPalette,
  },
  components: getComponents('light', lightPalette),
});

// Dark theme for game-play and game-edit pages
export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    ...darkPalette,
  },
  components: getComponents('dark', darkPalette),
});
export default lightTheme;
